type Environment = {
    REACT_APP_LUXOR_LOCALIZATION_FILES_URL: string
}

export const environment: Environment = {
    REACT_APP_LUXOR_LOCALIZATION_FILES_URL:
        process.env.REACT_APP_LUXOR_LOCALIZATION_FILES || 'REACT_APP_LUXOR_LOCALIZATION_FILES_URL_PLACEHOLDER'
}
